import request from '@/api/request'
// 存储下拉框数据 会优先访问本地已经存在的下拉框数据，没有才会去后台获取
const state = {
  select: {}
}

const mutations = {
  setselect: (state, data) => {
    state.select[data.key] = data.value
  },
}

const actions = {
  QuerySelect: function ({ state }, names) {
    return new Promise(resolve => {
      let o = {}
      let notNames = []
      // 先获取本地的
      names.forEach(e => {
        if (state.select[e]) {
          o[e] = state.select[e]
        } else {
          notNames.push(e)
        }
      });
      if (notNames.length > 0) {
        // console.log("发送了请求")
        request({
          url: 'CUSTOMER-SERVE/bic-vallist/getValueList',
          method: 'post',
          data: {
            "types": notNames,
            "domain": 'center'
          }
        }).then(v => {
          Object.assign(o, v.data)
          Object.assign(state.select, v.data)
          resolve(o)
        })
      } else {
        resolve(o)
      }
    })
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
